<div class="content">
    <div class="row items-push">
        <div class="col-sm-12 text-left">
            <ol class="breadcrumb push-10-t">
                <li><a [routerLink]="['/']">Inicio</a></li>
                <li><span class="link-effect">Actos - Condiciones</span></li>
            </ol>
        </div>
    </div>
  </div>
  
  <div class="content">
    <div class="block">
      <div class="block-header">
        <h3 class="block-title">Actos - Condiciones</h3>
    </div>
    
  
  <div class="block-content">
    <div class="form-horizontal">
      <div class="form-group">
        <label class="col-md-2 control-label">Nombre:</label>
        <div class="col-md-4">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input matInput type="text" placeholder="Nombre" [(ngModel)]="filter.nombre" maxlength="40">
            </mat-form-field>                    
        </div>
        <label class="col-md-2 control-label">Estado:</label>
        <div class="col-md-4">
          <mat-form-field appearance="outline">
            <mat-label>
              Seleccione
            </mat-label>
            <mat-select matSelect [(ngModel)]="filter.idEstado">
              <mat-option *ngFor="let item of listaEstados; index as i;" [value]='item.idParametroDetalle'>{{item.valor}}</mat-option>
            </mat-select>
          </mat-form-field>   
        </div>                
    </div>
  
    <div class="form-horizontal">
      <div class="form-group">
          <div class="col-sm-6 text-left">
            <a class="btn btn-naranja" mat-raised-button [routerLink]="['/configuracion', 'actos-condicion', 'registrar']"><mat-icon>description</mat-icon> Nuevo Acto - Condición</a>
            <!-- [routerLink]="['/solicitudes-engie/registrar']" -->
            <!-- <a class="btn btn-celeste" mat-raised-button [routerLink]="['/solicitudes-engie, 'exportar']">Exportar</a> -->
          </div>
          <div class="col-sm-6 text-right">
            <a class="btn btn-cyan" mat-raised-button (click)="search()" ><mat-icon>search</mat-icon> Buscar</a>
          </div>
      </div>
    </div>
    <div class="table-responsive">
      <table mat-table [dataSource]="model.items" class="table table-striped table-vcenter">
          <ng-container matColumnDef="id">
            <th mat-header-cell *matHeaderCellDef>Id</th>
            <td mat-cell *matCellDef="let element">{{ element.idActoCondicion }}</td>
          </ng-container>
      
          <ng-container matColumnDef="nombre">
            <th mat-header-cell *matHeaderCellDef>Nombre</th>
            <td mat-cell *matCellDef="let element">{{ element.nombre }}</td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef>Estado</th>
            <td mat-cell *matCellDef="let element">{{ element.estado }}</td>
          </ng-container>
      
          <ng-container matColumnDef="acciones">
              <th mat-header-cell *matHeaderCellDef>Acciones</th>
              <td mat-cell *matCellDef="let element"> 
                <a mat-icon-button color="primary" aria-label="Editar" [routerLink]="['/configuracion/', 'actos-condicion', element.idActoCondicion]">
                  <!-- (click)="openDialog(element)" -->
                  <mat-icon>create</mat-icon>
                </a>
              </td>
            </ng-container>
  
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      
        </table>  

        <mat-paginator #paginator [length]="resultsLength" [pageSize]="30" 
              (page)="getPaginatorData($event)"
              [pageSizeOptions]="[30, 50, 100]"></mat-paginator>
      </div>
  
    </div>
  </div>
  </div>